import { useMemo } from 'react';

import { type AddOnKey } from '@air/api';

import { useFetchAnyWorkspacePermissions } from '~/hooks/useFetchAnyWorkspacePermissions';
import { useCurrentWorkspaceAddOns } from '~/swr-hooks/workspaces/addOns/useCurrentWorkspaceAddOns';
import { canViewAddOns } from '~/utils/permissions/workspacePermissions';

export const useCanViewPrivateAddOn = ({ key }: { key: AddOnKey }) => {
  const { data: permissions } = useFetchAnyWorkspacePermissions();
  const { data: addOns, isLoading } = useCurrentWorkspaceAddOns({ enabled: canViewAddOns(permissions) });

  const addOn = useMemo(() => addOns?.data.find((addOn) => addOn.key === key), [key, addOns?.data]);

  const enabled = !!addOn?.enabled;
  const visible = !!addOn?.visible;

  return {
    canViewAddOn: enabled && visible,
    enabled,
    visible,
    isLoading,
  };
};
